import OmronFooter from "components/OmronFooter";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { selectCountry } from "features/signup";
import PageTitle from "components/PageTitle";
import OmronHeader from "components/OmronHeader";
import { useTranslation } from "react-i18next";
import { COUNTRY_JP } from "common/constants";
import { SignupFormJapan } from "./SignupFormJapan";
import { SignupFormOthers } from "./SignupFormOthers";

const SignupInput: React.FC = (): JSX.Element => {
  const country = useSelector(selectCountry);
  const { t } = useTranslation();

  // Use state instead of ref to re-render the sign-up form
  // immediately after the position of PageMain is fixed.
  const [main, setMain] = useState<HTMLElement | null>(null);

  return (
    <Wrapper>
      <OmronHeader
        link={{ label: t("common.label.breadcrumbsSignin"), path: "/" }}
        label={[t("common.label.breadcrumbsSignup")]}
      />
      <PageMain ref={setMain}>
        <InnerDiv>
          <PageTitle
            title={t("signupPage.label.inputTitle")}
            text={t("signupPage.text.inputDescription")}
          />
          {country === COUNTRY_JP ? (
            <SignupFormJapan scrollOffset={main?.offsetTop ?? 0} />
          ) : (
            <SignupFormOthers scrollOffset={main?.offsetTop ?? 0} />
          )}
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </Wrapper>
  );
};
export default SignupInput;

const Wrapper = styled.div`
  font-family: "源ノ角ゴシック Regular", "源ノ角ゴシック", "Noto Sans JP",
    "Roboto", Helvetica, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro",
    "メイリオ", "Meiryo", "Meiryo UI", sans-serif;
  color: #333333;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
`;

const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;
